import { cloneElement, Children } from 'react';
import PropTypes from 'prop-types';

// Wrap the text prop in a var tag
// If children are passed instead of text, add a notranslate attr to each child

export default function NoTranslate(props) {
  const { text, children } = props;

  if (text) {
    return <var>{text}</var>;
  }

  const noTranslatedChildren = Children.map(children, (child) => {
    if (typeof child === 'string') {
      return <var>{child}</var>;
    }

    return cloneElement(child, {
      notranslate: 'notranslate',
    });
  });

  return <>{noTranslatedChildren}</>;
}

NoTranslate.defaultProps = {
  text: '',
  children: '',
};

NoTranslate.propTypes = {
  text: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
};
